import styled from 'styled-components';

export const MobileCellComponentContainer = styled.div`
  /* background-color: red; */
  border-top: 1px solid #bdbdbd;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  height: 100%;
  width: 100%;
  padding: 20px 0;
  p,
  div {
    font-weight: 600;
  }
`;

export const MobileCellHeader = styled.div`
  grid-column: 1 / -1;
  grid-row: 1 / 2;
  font-size: 24px;
`;

export const MobileCellStatus = styled.div`
  grid-column: 1 / 2;
  grid-row: 2 / -1;
`;

export const MobileDelNote = styled.div`
  grid-column: 2 / -1;
  grid-row: 2 / -1;
  text-align: right;
`;
